<template>
    <div id="side-nav">
        <div class="list-group border list-group-flush">
            <router-link
                v-for="(item, index) in navigation"
                :key="index"
                :to="item.to"
                class="list-group-item list-group-item-action"
                active-class="active"
                exact-active-class="active"
                exact
            >
                <oc-icon v-if="item.icon" :type="item.icon" />
                {{item.title}}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "SideNav",
    data() {
        return {
            navigation: [
                {to: '/app/dashboard', icon: 'home', title: 'Dashboard'},
                {to: '/app/profile', icon: 'user-o', title: 'Profile'},
                {to: '/app/profile/change-password', icon: 'lock', title: 'Change Password'}
            ]
        }
    }
}
</script>

<style scoped>
#side-nav {
    height:100%;
    width: 100%;
    background: #eee;
    padding: 2px;
}

    #side-nav .list-group-item-action.active {
        background: #5988b9;
        border-color: #dfdfdf;
    }

    #side-nav .list-group-item-action {
        margin-bottom: 2px;
    }

    #side-nav .list-group-item-action:not(.active):hover {
        background: #e2e2e2;
    }

    #side-nav .list-group-item-action i {
        margin-right: 3px;
    }
</style>
